interface TimeRow {
  /** Nome del campo su formData (start_time, check_in_time, …). */
  id: string;
  /** Etichetta corta a sinistra dell'input (Da, A, Check-in, …). */
  label: string;
}

interface TimeRangeRowsProps {
  rows: TimeRow[];
  values: Record<string, unknown>;
  onChange: (patch: Record<string, string>) => void;
}

/**
 * Coppia di orari impaginata come le righe di intervallo del modale richieste:
 * un solo box con bordo, etichetta breve a sinistra e input trasparente.
 * Condivisa dalle modali attività per non riscrivere lo stesso markup sei volte.
 */
export const TimeRangeRows = ({ rows, values, onChange }: TimeRangeRowsProps) => (
  <div className="divide-y divide-gray-200 rounded-md border border-input">
    {rows.map((row) => (
      <div key={row.id} className="flex h-9 items-center gap-1.5 px-2.5">
        <label htmlFor={row.id} className="w-16 shrink-0 text-[11px] text-gray-500">
          {row.label}
        </label>
        <input
          id={row.id}
          type="time"
          value={(values[row.id] as string) || ''}
          onChange={(e) => onChange({ [row.id]: e.target.value })}
          className="w-full bg-transparent text-sm outline-none"
        />
      </div>
    ))}
  </div>
);

export default TimeRangeRows;
